var map = {
	"./ads.js": 96448,
	"./amazonCase.js": 9300,
	"./auth.js": 42418,
	"./common.js": 52409,
	"./demo.js": 63035,
	"./finance.js": 56256,
	"./logistics.js": 7757,
	"./product.js": 64129,
	"./promotions.js": 73670,
	"./shop.js": 17904,
	"./statistics.js": 55947,
	"./system.js": 82193,
	"./warehouse.js": 5629
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96968;